import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import styled from "styled-components";

import background from "../assets/background.png";


const Popup = styled.div`
  width: 400px;
  height: 250px;
  color: #fff;
  background: #6929c4;
  padding: 40px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  position: absolute;
  z-index: 90;
  top: calc(50% - 145px);
  left: calc(50% - 220px);
  display: flex;
  flex-direction: column;
`



export default (props) => {

return (
<Popup as={motion.div} variants={props.variants} style={props.style} animate={props.showShop ? "open": "closed"} >
    <h3>Modal title</h3>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto dolores
      molestias praesentium impedit. Facere, perferendis voluptate at, amet
      excepturi ratione mollitia nemo ipsum odit impedit doloremque rerum.
      Quisquam, dolorum at?
    </p>
  </Popup>


);



};
